import { render, staticRenderFns } from "./HitList.vue?vue&type=template&id=0b6dae26&"
import script from "./HitList.vue?vue&type=script&lang=ts&"
export * from "./HitList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports